"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalForageCache = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _localforage = _interopRequireDefault(require("localforage"));
var _Cache = require("./Cache");
class LocalForageCache extends _Cache.BaseCache {
  constructor(storeName, cacheDuration = 0) {
    super(cacheDuration);
    (0, _defineProperty2.default)(this, "store", void 0);
    this.store = _localforage.default.createInstance({
      name: storeName
    });
  }
  read(key) {
    return this.store.getItem(key);
  }
  async write(key, entry) {
    await this.store.setItem(key, entry);
  }
  async removeItem(key) {
    await this.store.removeItem(key);
  }
  async clean(age) {
    let keys = await this.store.keys();
    for (let key of keys) {
      let item = await this.store.getItem(key);
      if (Date.now() - item.t.getTime() > age) {
        await this.store.removeItem(key);
      }
    }
  }
}
exports.LocalForageCache = LocalForageCache;
//# sourceMappingURL=LocalForageCache.js.map